module.exports = {"id":"216194","name":"Dani García","rating":"81","photo":"./data/images/photos/2/216194.png","club":{"name":"SD Eibar","logo":"./data/images/clubs/SDEibar.png"},"positions":["MDC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DaniGarcia0.json
// module id = 913
// module chunks = 0